import { Auth } from 'aws-amplify'
import { getProgramData, showBuildingPicker } from '../redux/app/actions'
import { StorageService } from './StorageService'

export const setCurrentBuilding = (data) => {
    // Store the current building data with a flag indicating it was explicitly selected
    const enhancedData = {
        ...data,
        __wasExplicitlySelected: true
    };
    StorageService.set('currentBuilding', enhancedData)

    Auth.currentAuthenticatedUser().then((user) => {
        // getProgramData is the single source of routing — it pushes exactly one
        // history entry per building switch once data has loaded.
        getProgramData(data, user)
        showBuildingPicker(false)
    })
}
